import { notification } from 'antd';
import { FormikBag, FormikErrors, FormikProps } from 'formik';
import parsePhoneNumberFromString from 'libphonenumber-js';

import { apiClient } from '../../../../graphql/api/apiClient';
import {
  updatePropertyVirtualDirectoryDocument,
  UpdatePropertyVirtualDirectoryInput,
  updatePropertyVirtualDirectoryMutation,
  updatePropertyVirtualDirectoryMutationVariables,
  virtualDirectoryAuditQuery,
} from '../../../../graphql/api/generated';
import { displayErrorMessage } from '../../../../utils';
import { validateTimetable } from '../../../helpers/validate/timetable';

type Property = virtualDirectoryAuditQuery['virtualDirectoryAudit']['property'];

export interface IPropertyVirtualDirectoryFormProps {
  property: Property;
}

export type IPropertyVirtualDirectoryFormValues = UpdatePropertyVirtualDirectoryInput & {
  propertyId: string;
  updatedAt: string;
}

export interface IPropertyVirtualDirectoryFormMergedProps extends
  IPropertyVirtualDirectoryFormProps,
  FormikProps<IPropertyVirtualDirectoryFormValues> {}

export function mapPropsToValues(
  props: IPropertyVirtualDirectoryFormProps,
): IPropertyVirtualDirectoryFormValues {
  return {
    ...props.property.propertyVirtualDirectory,
  };
}

export function validate(
  values: IPropertyVirtualDirectoryFormValues,
  props: IPropertyVirtualDirectoryFormProps,
) {
  const errors: FormikErrors<IPropertyVirtualDirectoryFormValues> = {};

  if (
    values.leasingOfficePhoneNumber &&
    !(parsePhoneNumberFromString(values.leasingOfficePhoneNumber || '', 'US')?.isValid())
  ) {
    errors.leasingOfficePhoneNumber = 'Please provide a valid phone number';
  }

  return {
    ...errors,
    ...validateTimetable(values, 'leasingOfficeHours'),
  };
}

export async function handleSubmit(
  values: IPropertyVirtualDirectoryFormValues,
  formikBag: FormikBag<IPropertyVirtualDirectoryFormProps, IPropertyVirtualDirectoryFormValues>
) {
  try {
    const { propertyId } = values;

    await apiClient.mutate<
      updatePropertyVirtualDirectoryMutation,
      updatePropertyVirtualDirectoryMutationVariables
    >({
      variables: {
        propertyId,
        input: {
          published: values.published,
          userDisplayNameFormat: values.userDisplayNameFormat,
          leasingOfficePhoneNumber: values.leasingOfficePhoneNumber,
          leasingOfficeDisplayName: values.leasingOfficeDisplayName,
          leasingOfficeHours: values.leasingOfficeHours,
        },
      },
      mutation: updatePropertyVirtualDirectoryDocument,
    });

    await apiClient.resetStore(); // Refetch VD audit

    notification.success({
      message: 'Success',
      description: 'The Virtual Directory settings were successfully saved!',
    });
  } catch (error) {
    formikBag.setSubmitting(false);
    displayErrorMessage(error);
  }
}
